
import { toast } from "sonner";
import { resizeImageIfNeeded } from "./imageUtils";
import { Dispatch, SetStateAction } from "react";

export const handleFileUpload = (
  event: React.ChangeEvent<HTMLInputElement>,
  setImageCallback: (image: string) => void,
  setModeCallback: Dispatch<SetStateAction<"initial" | "camera" | "preview" | "gallery">>
): void => {
  const file = event.target.files?.[0];
  console.log("File selected:", file);
  if (file) {
    // Check file size - limit to 5MB
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image is too large. Please select an image under 5MB.");
      return;
    }
    
    const reader = new FileReader();
    reader.onload = (e) => {
      const result = e.target?.result as string;
      // Resize large images before setting
      resizeImageIfNeeded(result, 1200, 1200, (resizedImage) => {
        console.log("Image resized and ready for preview");
        setImageCallback(resizedImage);
        setModeCallback("preview");
      });
    };
    reader.readAsDataURL(file);
    
    // Reset the file input so the same file can be selected again if needed
    event.target.value = '';
  }
};
